





















import { Component, Prop, Vue } from 'vue-property-decorator';
import CodeMirror from 'codemirror';

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { codemirror } from 'vue-codemirror-lite';
import { ParserError } from 'css';

require('codemirror/mode/css/css.js');
require('codemirror/addon/hint/show-hint.js');
require('codemirror/addon/hint/show-hint.css');
require('codemirror/addon/hint/css-hint.js');

@Component({
  components: {
    codemirror
  }
})
export default class StylesheetInput extends Vue {
  @Prop({ type: String, required: true }) stylesheetString!: string;
  @Prop({ type: Error, default: null}) stylesheetParserError!: ParserError;

  options: CodeMirror.EditorConfiguration = {
    mode: 'css',
    tabSize: 2,
    lineNumbers: true,
    lineWrapping: true,
    extraKeys: {'Ctrl-Space': 'autocomplete'},
    screenReaderLabel: 'CSS Stylesheet'
  };

  // Computed prop used so we don't mutate the parent prop
  get internalStylesheetString() {
    return this.stylesheetString;
  }
  set internalStylesheetString(value) {
    this.$emit('update:stylesheetString', value)
  }
}
